export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Technology", path: "/technology" },
  { label: "Solutions", path: "/solutions" },
  { label: "Innovation", path: "/innovation" },
  { label: "Trust Center", path: "/trust-center" },
  { label: "Ecosystem", path: "/ecosystem" },
  { label: "Impact", path: "/impact" },
  { label: "Partners", path: "/partners" },
  { label: "Investors", path: "/investors" },
  { label: "Careers", path: "/careers" },
];

export const TECH_LINE = "AI • DeepTech • Fraud Intelligence • Risk Intelligence • RegTech • Cybersecurity • Privacy by Design • Payments • Compliance • Financial Infrastructure";

export const MARQUEE_ITEMS = [
  "Fraud Intelligence", "Risk Intelligence", "RegTech", "Privacy by Design",
  "Cybersecurity", "Compliance-First", "Financial Infrastructure", "Bharat-First",
  "Secure by Design", "AI-Driven",
];

export const PROBLEMS = [
  { icon: "ShieldAlert", title: "Fraud & Cyber Risk", body: "Sophisticated financial fraud requires intelligent, real-time risk detection and prevention." },
  { icon: "Layers", title: "Fragmented Ecosystems", body: "Customers and businesses often depend on multiple platforms for different financial services." },
  { icon: "Fingerprint", title: "Identity & Privacy", body: "Identity misuse, onboarding risk and growing privacy concerns." },
  { icon: "Route", title: "Last-Mile Access", body: "Millions of users still rely on assisted and agent-led financial services." },
  { icon: "Scale", title: "Trust & Compliance", body: "The next generation of FinTech requires security, privacy and regulatory readiness by design." },
];

export const SERVICE_GROUPS = [
  { title: "Payments", items: ["UPI", "AEPS", "Micro ATM", "DMT", "BBPS"], status: "In Development", tone: "dev" },
  { title: "Banking", items: ["Financial Products & Services", "Lending", "Credit Card", "Utility Bill Payments", "Finances"], status: "Planned", tone: "planned" },
  { title: "Protection", items: ["Insurance", "Risk Intelligence", "Fraud Prevention"], status: "Planned", tone: "planned" },
  { title: "Access", items: ["Retailers", "Merchants", "Agents", "SHGs", "Consumers"], status: "In Development", tone: "dev" },
];

export const BUSINESS_IMPACT = [
  "Reduce Fraud & Losses",
  "Lower Operational Cost",
  "Build Trust & Confidence",
  "Enable Inclusive Growth",
  "Stay Compliant. Always",
];

export const INTELLIGENCE = [
  { icon: "BrainCircuit", title: "AI Fraud Intelligence", body: "Models designed to detect anomalous behaviour and stop fraud before it settles." },
  { icon: "Activity", title: "Real-Time Risk Intelligence", body: "Transaction, device and behavioural signals evaluated in real time." },
  { icon: "FileCheck", title: "RegTech", body: "Compliance checks embedded into workflows — automated, auditable, always on." },
  { icon: "Lock", title: "Privacy by Design", body: "Data minimisation and consent-first architecture from the foundation." },
  { icon: "ShieldCheck", title: "Cybersecurity", body: "Secure API architecture and defence-in-depth across every layer." },
];

export const STEPS = [
  { num: "01", title: "Connect", body: "Banks, financial institutions, payment ecosystems and technology partners." },
  { num: "02", title: "Enable", body: "Payments, banking, insurance and financial services." },
  { num: "03", title: "Intelligence", body: "AI-powered fraud, risk, compliance and behavioural intelligence." },
  { num: "04", title: "Protect", body: "Safer and more transparent financial experiences." },
];

export const DIFF_ROWS = [
  ["Transaction focused", "Intelligence focused"],
  ["Fragmented services", "Unified infrastructure"],
  ["Reactive risk controls", "Proactive risk intelligence"],
  ["Compliance later", "Compliance-first"],
  ["Digital-only", "Tech + Touch"],
  ["Generic infrastructure", "Bharat-focused infrastructure"],
  ["Payment-centric", "Financial ecosystem"],
];

export const SOLUTION_TABS = [
  {
    id: "consumers",
    label: "Consumers",
    headline: "Financial services that feel safe by default.",
    points: [
      "Unified access to payments, banking and protection journeys, designed to be simple and secure.",
      "Privacy-first experiences with security built in, not bolted on.",
      "Assisted and self-serve journeys designed for Bharat's real world.",
    ],
  },
  {
    id: "merchants-agents",
    label: "Merchants & Agents",
    headline: "A serious toolkit for last-mile financial access.",
    points: [
      "Planned service rails including UPI, AEPS, Micro ATM, DMT and BBPS.",
      "Assisted-service workflows for customers who need a human touch.",
      "Risk and compliance guardrails designed into every transaction.",
    ],
  },
  {
    id: "banks-fis",
    label: "Banks & Financial Institutions",
    headline: "Infrastructure that carries risk intelligence with it.",
    points: [
      "API-led integration across payments, banking and insurance rails.",
      "Real-time fraud and risk signals designed to reduce losses.",
      "Compliance-first architecture aligned with regulatory expectations.",
    ],
  },
  {
    id: "fintechs",
    label: "FinTechs",
    headline: "Build on intelligence, not just rails.",
    points: [
      "Infrastructure designed around fraud, risk and compliance intelligence.",
      "A shared intelligence layer instead of rebuilding trust systems.",
      "Faster go-to-market on compliance-by-design foundations.",
    ],
  },
  {
    id: "institutions",
    label: "Institutions",
    headline: "Transparent rails for public and institutional programs.",
    points: [
      "Last-mile assisted access for citizen-facing financial services.",
      "Audit-friendly, privacy-by-design architecture.",
      "Built for inclusion across Tier 2–6 Bharat.",
    ],
  },
];

export const ARCH_LAYERS = [
  { name: "Experience Layer", items: ["Consumers", "Merchants", "Agents", "Partners"], desc: "Every journey — self-serve or assisted — meets the platform here, designed for Bharat's languages, devices and realities." },
  { name: "TimePe Platform", items: ["API-Led Core", "Unified Journeys"], desc: "An API-led financial infrastructure core that orchestrates services, journeys and participants in one framework." },
  { name: "Payments • Banking • Insurance", items: ["Payments", "Banking", "Insurance"], desc: "Financial service rails connected into one real-time decisioning framework rather than fragmented silos." },
  { name: "Intelligence Layer", items: ["Fraud", "Risk", "Compliance", "AI/ML"], desc: "The differentiator: AI-driven fraud intelligence, risk intelligence and compliance automation around every transaction." },
  { name: "Security Layer", items: ["Privacy", "Identity", "API Security"], desc: "Privacy by design, identity protection and secure API architecture beneath every layer above it." },
  { name: "Ecosystem Integration", items: ["Banks", "NBFCs", "Insurers", "Payment Networks"], desc: "Institutional integrations that plug TimePe into India's existing financial ecosystem." },
];

export const SECURITY_PILLARS = [
  { icon: "Lock", title: "Privacy by Design", body: "Data minimisation, consent-first flows and privacy engineered into the foundation — not retrofitted." },
  { icon: "ShieldAlert", title: "Fraud Prevention", body: "Intelligence designed to identify and stop fraud before value moves." },
  { icon: "Fingerprint", title: "Identity Protection", body: "Onboarding and identity safeguards built to counter misuse and impersonation." },
  { icon: "ServerCog", title: "Secure API Architecture", body: "Defence-in-depth across APIs, integrations and data flows." },
];

export const BHARAT_TRAITS = ["Multilingual", "Accessible", "Assisted", "Affordable", "Inclusive", "Trust-Centric"];

export const BHARAT_CARDS = [
  { icon: "HeartHandshake", title: "Assisted Access", body: "Technology that works with human help at the last mile, not against it." },
  { icon: "Languages", title: "Multilingual Experiences", body: "Interfaces designed for Bharat's languages from day one." },
  { icon: "Users", title: "Agent-Led Distribution", body: "Retailers, agents and SHGs as first-class participants in the network." },
  { icon: "GraduationCap", title: "Financial Literacy", body: "Journeys that build understanding alongside access." },
  { icon: "Globe2", title: "Inclusive Infrastructure", body: "From rural to semi-urban to urban — one infrastructure, every reality." },
];

export const INNOVATIONS = [
  "Fraud & Risk Intelligence",
  "Privacy-Preserving Financial Experiences",
  "Compliance-by-Design",
  "Intelligent Digital Onboarding",
  "Unified Financial Infrastructure",
  "AI-Powered Financial Intelligence",
  "Bharat-First Technology",
];

export const MOAT_NODES = [
  "Distribution", "Financial Journeys", "Intelligence Signals", "Better Risk Intelligence",
  "Better Experience", "Ecosystem Adoption", "Stronger Network",
];

export const IMPACT_TARGETS = [
  { value: 50000, suffix: "+", label: "Target Agent / Retailer Network" },
  { value: 1, suffix: "M+", label: "Long-Term Individuals Targeted" },
  { text: "Tier 2–6", label: "Priority Markets" },
  { text: "Bharat-First", label: "Design Philosophy" },
];

export const VALIDATIONS = [
  { org: "IC IIT Patna", program: "IIT Patna Incubation Centre", institution: "Indian Institute of Technology", location: "Patna, Bihar, India", status: "Pre-Incubated / Prototype Grant", logos: ["/assets/ic-iit-patna-1.png", "/assets/ic-iit-patna-2.png"], logoAlt: "IC IIT Patna — IIT Patna Incubation Centre logo" },
  { org: "STPI EmTeK CoE", program: "STPI & AIC STPINEXT Initiatives", institution: "Software Technology Parks of India (STPI)", location: "Bhubaneswar, Odisha, India", status: "Incubated / Prototype Grant", logos: ["/assets/stpi-emtek-coe-1.png", "/assets/stpi-emtek-coe-2.png"], logoAlt: "STPI EmTeK CoE — STPI & AIC STPINEXT Initiatives logo" },
  { org: "IIT Jodhpur — TISC", program: "Technology Innovation and Start-Up Centre", institution: "Indian Institute of Technology", location: "Jodhpur, Rajasthan, India", status: "Selected & Incubated", logos: ["/assets/iit-jodhpur-tisc-1.png", "/assets/iit-jodhpur-tisc-2.png"], logoAlt: "IIT Jodhpur TISC — Technology Innovation and Start-Up Centre logo" },
  { org: "AIC Techno", program: "AIC Techno Innovation and Incubation Council", institution: "Techno India University", location: "Kolkata, West Bengal, India", status: "Selected & Pre-Incubated", logos: ["/assets/aic-techno-1.png", "/assets/aic-techno-2.png"], logoAlt: "AIC Techno Innovation and Incubation Council logo" },
  { org: "AIC GGSIPU", program: "AIC GGSIPU Foundation", institution: "Guru Gobind Singh Indraprastha University", location: "New Delhi, India", status: "Selected & Incubated", logos: ["/assets/aic-ggsipu-1.png", "/assets/aic-ggsipu-2.png"], logoAlt: "AIC GGSIPU Foundation logo" },
];

export const ROADMAP = [
  { phase: "Phase 1", title: "Foundation", items: ["Prototype", "Architecture", "Validation", "Incubation"], status: "Underway", tone: "dev" },
  { phase: "Phase 2", title: "Infrastructure", items: ["Banking integrations", "Payment integrations", "Risk Engine", "Compliance systems"], status: "Planned", tone: "planned" },
  { phase: "Phase 3", title: "Scale", items: ["Agent network", "Institutional partnerships", "Geographic expansion"], status: "Planned", tone: "planned" },
  { phase: "Phase 4", title: "Intelligence", items: ["Advanced AI", "Fraud intelligence", "Risk intelligence", "RegTech"], status: "Planned", tone: "planned" },
  { phase: "Phase 5", title: "Ecosystem", items: ["Payments", "Banking", "Insurance", "Commerce", "Logistics", "Cross-border opportunities"], status: "Future", tone: "future" },
];

export const ECOSYSTEM_PARTICIPANTS = [
  "Banks", "NBFCs", "FinTechs", "PSPs", "Insurance",
  "Agents", "Retailers", "Merchants", "Citizens", "Institutions",
];

export const PARTNER_CATEGORIES = [
  { icon: "Landmark", title: "Banks", body: "Co-build compliant, intelligence-led journeys on shared rails." },
  { icon: "Building2", title: "NBFCs", body: "Reach last-mile borrowers with risk intelligence built in." },
  { icon: "Umbrella", title: "Insurance Companies", body: "Distribute protection products through trusted assisted channels." },
  { icon: "Cpu", title: "FinTechs", body: "Build on infrastructure with fraud, risk and compliance intelligence." },
  { icon: "Banknote", title: "Payment Ecosystem", body: "Connect payment networks to a unified decisioning framework." },
  { icon: "CircuitBoard", title: "Technology Partners", body: "Integrate AI, security and data capabilities into the platform." },
  { icon: "Landmark", title: "Government & Institutions", body: "Deliver citizen-facing financial services with transparency and trust." },
];

export const DEPARTMENTS = [
  { icon: "Code2", title: "Engineering", body: "Platform, APIs and infrastructure built for scale and reliability." },
  { icon: "BrainCircuit", title: "AI/ML", body: "Fraud, risk and behavioural intelligence systems." },
  { icon: "ShieldCheck", title: "Cybersecurity", body: "Defence-in-depth across every layer of the stack." },
  { icon: "Boxes", title: "Product", body: "Journeys designed around Bharat's real-world users." },
  { icon: "Banknote", title: "FinTech", body: "Payments, banking and financial-services domain depth." },
  { icon: "FileCheck", title: "Compliance", body: "Regulatory readiness engineered into every workflow." },
  { icon: "Network", title: "Business Operations", body: "Distribution, partnerships and ecosystem execution." },
];

export const INTERESTS = [
  "Investment", "Partnership", "Banking Integration", "FinTech Integration",
  "Government / Institution", "Technology", "Media", "Careers", "General Enquiry",
];

export const FOUNDERS = [
  {
    name: "Satyajeet Kumar",
    role: "Founder, Director & CEO",
    photo: "/assets/satyajeet-kumar.webp",
    expertise: ["FinTech", "Banking", "Financial Inclusion", "Digital Public Infrastructure"],
    bio: "Satyajeet brings over 7 years of hands-on experience across FinTech, banking, financial inclusion and Digital Public Infrastructure. His experience includes serving as a Business Correspondent with Bank of Baroda and as a VLE with CSC e-Governance / Digital India, along with experience within the UIDAI Aadhaar ecosystem. He has developed domain expertise across UPI, AEPS, BBPS, DMT, agent networks, KYC/AML and compliance, and has participated in large-scale government projects and citizen-service initiatives. This combination of banking, FinTech and grassroots execution gives him a practical understanding of Bharat's financial ecosystem—from customers and agents to banking operations, digital infrastructure and compliance, forming the foundation for building TimePe.",
  },
  {
    name: "Aeligeti Sreekar",
    role: "Co-Founder, Director & CTO",
    photo: "/assets/aeligeti-sreekar.webp",
    expertise: ["AI/ML", "Risk Intelligence", "Generative AI", "Financial Technology"],
    bio: "Sreekar leads the technology and AI direction behind TimePe. With a foundation in Computer Science and AI/ML, his expertise spans AI/ML engineering, intelligent identity and risk-detection systems, Generative AI, LLMs, RAG, fine-tuning, Python and FastAPI. He focuses on translating advanced AI capabilities into scalable, production-oriented financial technology, developing intelligent systems that can support TimePe's risk intelligence, fraud prevention and financial infrastructure. His role bridges AI research, engineering and product execution, helping transform TimePe's technology vision into practical, scalable solutions for digital finance.",
  },
];

export const FOUNDER_TIMELINE = [
  "Grassroots Financial Services",
  "Banking & Digital Public Infrastructure",
  "FinTech Ecosystem",
  "Avyagrah Tech Innovations",
  "TimePe",
];

export const CONTACT_EMAIL = "avyagrah.tech@gmail.com";
export const CONTACT_EMAILS = ["md.ceo@avyagrahtech.com", "cto@timepe.org"];
